export default __webpack_public_path__ + "static/media/shortcut_fund-fact-sheet.a9cc8372.svg";